import React from 'react'

import { Container, Row, Col } from 'react-bootstrap'
import LinkInternal from 'components/atoms/LinkInternal'
import Typography from 'components/atoms/Typography'
import CardNews from 'components/molecules/CardNews'
import { get } from 'lodash'
import { millisToHuman } from 'helpers/dates'
import { userCheckMobileScreen, renderIndexItemClass } from 'helpers/tools'

// Style
import './HighlightedNews.scss'

function HighlightedNews({ data, user }) {
  const { theme, news } = data
  const firstItemRender = get(data, 'first')
  const lastItemRender = get(data, 'last')
  const id = get(data, 'id')
  const isMobile = userCheckMobileScreen()
  const indexItemClass = renderIndexItemClass(firstItemRender, lastItemRender)
  const items = get(news, 'items')
  return (
    <Container id={id} className={`highlighted-news bg-gray-300 ${theme?.classes} ${indexItemClass}`} fluid="fluid">
      <Container>
        <Row>
          <Col sm={12} md={6}>
            <Typography variant="h3" color="secondary" cssClass="title-semibold-md title">
              {get(data, 'title')}
            </Typography>
          </Col>
          <Col sm={12} md={6} className="d-flex justify-content-md-end">
            <LinkInternal
              title={get(data, 'link.title')}
              url={get(data, 'link.url.path')}
              color={'primary'}
              icon="arrow-right"
              iconAlign="right"
            />
          </Col>
        </Row>

        {Array.isArray(items) && (
          <Row className="py-4">
            <Col sm={12} md={8} className="d-none d-md-flex highlighted">
              {items.length > 0 && (
                <CardNews
                  alt={get(items[0], 'media.entity.images.alt')}
                  url={items[0].url.path}
                  image={
                    isMobile
                      ? get(items[0], 'media.entity.images.medium.url')
                      : get(items[0], 'media.entity.images.wide.url')
                  }
                  date={millisToHuman(items[0].created)}
                  title={items[0].title}
                  preview={get(items[0], 'body.summary')}
                  highlight
                />
              )}
            </Col>
            <Col sm={12} md={4} className="side-bar">
              <Typography variant="h4" cssClass="title-semibold-md category">
                Destaques
              </Typography>
              {items
                .filter((item) => item.created != items[0].created || isMobile)
                .map((item) => (
                  <CardNews
                    alt={get(item, 'media.entity.image.alt')}
                    key={item.title}
                    url={item.url.path}
                    date={millisToHuman(item.created)}
                    title={item.title}
                    reduced
                  />
                ))}
              <LinkInternal
                title={'Acesse outros destaques'}
                url="/destaques"
                color={'primary'}
                icon="arrow-right"
                iconAlign="right"
                className="highlighted-news-side-bar-cta"
              />
            </Col>
          </Row>
        )}
      </Container>
    </Container>
  )
}

export default HighlightedNews
